export default __webpack_public_path__ + "static/media/sunnybrook.e4fb6b07.png";